import React from 'react'
import GenericButton from '../GenericButton'

function getValue (value: any, humidity?: any) {
  const temperature = isNaN(value) ? '-' : value.toFixed(2)
  const hasHumidity = humidity != null && !isNaN(humidity) && humidity !== 255
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  const tempPart = `${temperature} °C`
  if (!hasHumidity) return tempPart
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  return `${tempPart} · ${Math.round(humidity)}%`
}

interface OwnProps {
  children?: React.ReactNode
  onPress?: (...args: any[]) => any
  humidity?: number
}

// @ts-expect-error ts-migrate(2565) FIXME: Property 'defaultProps' is used before being assig... Remove this comment to see the full error message
type Props = OwnProps & typeof TemperatureSensor.defaultProps

// @ts-expect-error ts-migrate(2339) FIXME: Property 'offline' does not exist on type 'Props'.
export default function TemperatureSensor ({ onPress, offline, value, humidity, text, disable, removeButton, removeButtonPress, connectionStatus, onLongPress, hide, hideButtonPress }: Props) {
  return (
    <GenericButton
      icon="thermometer"
      // @ts-expect-error ts-migrate(2322) FIXME: Type '{ icon: string; text: any; status: string; o... Remove this comment to see the full error message
      text={text}
      status={getValue(value, humidity)}
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
      on={!offline}
      offline={offline}
      disable={disable}
      removeButton={removeButton}
      removeButtonPress={removeButtonPress}
      connectionStatus={connectionStatus}
      onLongPress={onLongPress}
      hide={hide}
      hideButtonPress={hideButtonPress}
    />
  )
}

TemperatureSensor.defaultProps = {
  children: null,
  onPress: () => { }
}
